(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const menuHeadings = document.querySelectorAll('.footer__item-title');

  menuHeadings.forEach(function (heading) {
    heading.addEventListener('click', function (e) {
      e.preventDefault(); // Prevent ghost click issues on iOS

      // parentElement is safer than closest() on older iOS Safari
      let menu = heading.parentElement;
      while (menu && !menu.classList.contains('footer_menu')) {
        menu = menu.parentElement;
      }

      if (menu) {
        menu.classList.toggle('open');
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
